import React, {Component} from 'react';

import AddressForm from '../account/AddressForm.jsx';
import Input from '../form/Input.jsx';
import Select from '../form/Select.jsx';

export default class AddressSelector extends Component {
    inputs = {}
    state = {
        is_edit: false,
        is_new: false
    }

    getValue = () => {
        let {account} = this.props;
        let adr = account.addresses.data.find(adr => adr._id === this.adr_select.getValue());

        if (this.state.is_edit) {
            let invalid = Object.keys(this.inputs).filter((key) => {
                let input = this.inputs[key];
                return input && !input.validate();
            });

            if (invalid.length) {
                let firstKey = invalid[0];
                this.inputs[firstKey].focus();
                return false;
            }

            return {
                to: `${account.info.name.given} ${account.info.name.family}`,
                name: {
                    given: account.info.name.given,
                    family: account.info.name.family
                },
                ...this.inputs.address.createObject()
            };
        }

        return {
            to: adr.to || `${account.info.name.given} ${account.info.name.family}`,
            name: {
                given: account.info.name.given,
                family: account.info.name.family
            },
            ...adr
        };
    }

    componentDidMount = () => {
        let adr = this.props.account.addresses.data.find(adr => adr._id === this.props.address._id);
        if (!adr) {
            this.setState({
                is_edit: true
            });
        }
    }

    handleAdrSelect = (event) => {
        this.setState({
            is_edit: this.adr_select.getValue() === 'new'
        });
    }

    handleEditClick = () => {
        this.setState({
            is_edit: true
        });
    }

    handleCancel = (event) => {
        event.preventDefault();
        this.setState({
            is_edit: false
        });
    }

    render () {
        let {address, account} = this.props;
        let name = address.to ? {given: address.to.split(' ')[0], family: address.to.split(' ')[1]} : account.info.name;

        let form = <div></div>;
        if (!address || this.state.is_edit) {
            form = (
                <div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6">
                            <Input ref={ref => (this.inputs.name_given = ref)} id="name.given" label="First Name" type="text" value={name.given} required errorMessage="Please enter a First Name" />
                        </div>
                        <div className="col-xs-12 col-sm-6">
                            <Input ref={ref => (this.inputs.name_family = ref)} id="name.family" label="Last Name" type="text" value={name.family} required errorMessage="Please enter a Last Name" />
                        </div>
                    </div>

                    <AddressForm ref={ref => (this.inputs.address = ref)} address={address} name={name} showName={this.props.showName} />
                </div>
            );
        }

        return (<div>
            <div className="checkout-selection">
                <Select ref={ref => (this.adr_select = ref)} value={address._id || 'new'} onChange={this.handleAdrSelect}>
                    {account.addresses.data.map((adr, index) => {
                        return <option key={adr._id} value={adr._id}>{adr.to || account.org.name.long} {adr.street.join(' ')} {adr.city} {adr.region} {adr.postal_code} {adr.country}</option>;
                    })}
                    <option value="new">New Address</option>
                </Select>
                {form}
            </div>
        </div>);
    }
}
